import { render, staticRenderFns } from "./currencyTabItem.vue?vue&type=template&id=41ccad97&scoped=true"
import script from "./currencyTabItem.vue?vue&type=script&lang=js"
export * from "./currencyTabItem.vue?vue&type=script&lang=js"
import style0 from "./currencyTabItem.vue?vue&type=style&index=0&id=41ccad97&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41ccad97",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/xrUxRsdL/0/acquirer/pingpong-acquirer-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41ccad97')) {
      api.createRecord('41ccad97', component.options)
    } else {
      api.reload('41ccad97', component.options)
    }
    module.hot.accept("./currencyTabItem.vue?vue&type=template&id=41ccad97&scoped=true", function () {
      api.rerender('41ccad97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/currencyTabItem.vue"
export default component.exports